import { render } from "./SzWorkflowDetail.vue?vue&type=template&id=1b86b319&scoped=true"
import script from "./SzWorkflowDetail.vue?vue&type=script&lang=ts"
export * from "./SzWorkflowDetail.vue?vue&type=script&lang=ts"

import "./SzWorkflowDetail.vue?vue&type=style&index=0&id=1b86b319&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1b86b319"

export default script